import { useTranslate } from "@similarweb/i18n-provider";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { LegacyBadge } from "app/pages/sales-intelligence/common-components/badge/LegacyBadge";
import { useIsIndustryTaxonomyOptedIn } from "app/pages/sales-intelligence/modules/industry/hooks/useIsIndustryTaxonomyOptedIn";
import { columnKeys } from "app/pages/sales-intelligence/utils/i18n/columns";

export const LegacyIndustryColumnHeader = () => {
    const { translate } = useTranslate();
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();
    const title = translate(columnKeys.title("industry"));

    if (!isIndustryTaxonomyOptedIn) {
        return title;
    }

    return (
        <Flex
            inline
            alignItems="center"
            gap="6px"
        >
            <Text fontVariant="captionTitle">{title}</Text>
            <LegacyBadge />
        </Flex>
    );
};
